import React from "react";
import Base from "../Layouts/Base";
import Footer from "../Components/Footer";

const Terms = () => (
  <Base>
    <div className="container termsWrapper my-3">
      <h3 className="text-center mb-4">Terms of Service</h3>
      <p className="text-center">Effective date: October 1, 2026</p>

      <section className="my-3">
        <h4>Agreement</h4>
        <p>
          These Terms are an agreement between you and Beach Collective LLC
          (&quot;Beach Collective&quot;, &quot;we&quot;, &quot;us&quot;). They
          cover our websites, the cleanup leaderboard, the sign-up and
          submission page, and our Telegram and X bots (together, the
          &quot;Program&quot;). By using the Program, you agree to these Terms
          and to our <a className="text-dark" href="/privacy">Privacy Policy</a>.
          If you don&apos;t agree, don&apos;t use the Program.
        </p>
      </section>

      <section className="my-3">
        <h4>Who can join</h4>
        <p>
          You must be at least 18 and able to enter a binding agreement. You
          can&apos;t use the Program if the law where you live prohibits it,
          including receiving or holding crypto tokens, or if you are subject
          to sanctions. You&apos;re responsible for following the laws that
          apply to you.
        </p>
      </section>

      <section className="my-3">
        <h4>Your account</h4>
        <ul className="terms-list">
          <li>
            One person, one account. You can sign in with email, a crypto
            wallet, X or Telegram, and link them into one account. Don&apos;t
            create extra accounts.
          </li>
          <li>
            Keep your sign-in methods secure. You&apos;re responsible for
            activity on your account.
          </li>
          <li>
            Your display name must not be offensive, misleading or impersonate
            anyone, including Beach Collective. We may reject or change names
            that break this rule.
          </li>
          <li>
            Accounts that sign in only with a wallet can earn points but must
            link Telegram, X or a confirmed email before claiming $BEACH.
          </li>
        </ul>
      </section>

      <section className="my-3">
        <h4>Submitting cleanups</h4>
        <ul className="terms-list">
          <li>
            Submit only photos you took of trash you personally collected. Each
            photo can be submitted once.
          </li>
          <li>
            Don&apos;t submit reused, edited, AI-generated, stock or someone
            else&apos;s photos, or stage the same trash for several submissions.
          </li>
          <li>
            We may limit how often you submit, for example a daily limit on the
            website.
          </li>
          <li>
            Submissions are checked automatically, including by AI image
            analysis. Weights and item counts are estimates. We decide whether
            a submission is verified and how many points it earns, and we may
            review, adjust or reverse results, including after they&apos;re
            awarded.
          </li>
          <li>
            If you think an estimate is wrong, you can request a correction.
            Large corrections may be reviewed by our team.
          </li>
        </ul>
        <p>
          <strong>Stay safe.</strong> Follow local rules and posted signs,
          don&apos;t enter private or protected areas, and don&apos;t handle
          needles, sharp objects or hazardous waste. Report those to local
          authorities instead. Dispose of what you collect properly. You take
          part at your own risk.
        </p>
      </section>

      <section className="my-3">
        <h4>Points and $BEACH</h4>
        <ul className="terms-list">
          <li>
            <strong>Points are rewards, not money.</strong> They have no cash
            value, aren&apos;t your property, and can&apos;t be sold,
            transferred or exchanged except by claiming $BEACH through the
            Program.
          </li>
          <li>
            <strong>Converting to $BEACH.</strong> We set the rate at which
            points convert to $BEACH and any caps, for example the maximum
            weight per cleanup that counts toward tokens (currently 5 kg). We
            may change rates, caps and rules going forward.
          </li>
          <li>
            <strong>Claiming.</strong> You can claim once your balance reaches
            the minimum (currently 2,500 $BEACH). Claims are all-or-nothing and
            paid in a regular settlement, currently once a day, to the BNB
            Smart Chain (BEP-20) wallet on your account.
          </li>
          <li>
            <strong>Your wallet is your responsibility.</strong> Check your
            payout address. Tokens sent to the address you gave us can&apos;t
            be recovered. You may need a small amount of BNB to move tokens
            later.
          </li>
          <li>
            <strong>Reviews and holds.</strong> We may delay, hold, reduce or
            cancel claims and points that we reasonably believe came from
            fraud, abuse, a mistake or a breach of these Terms.
          </li>
          <li>
            <strong>Taxes.</strong> You&apos;re responsible for any taxes on
            rewards you receive.
          </li>
          <li>
            <strong>Changes.</strong> We may change, pause or end the Program
            or $BEACH payouts. If we end the Program, we&apos;ll give at least
            30 days&apos; notice, and you can claim the $BEACH your points
            convert to during that time, with no minimum claim amount. Points
            not claimed by the end of the notice period expire.
          </li>
        </ul>
      </section>

      <section className="my-3">
        <h4>Referrals</h4>
        <p>
          You can invite people with your referral link. When someone joins
          with it and their first cleanup is verified, you each receive a bonus
          (currently 25 points), and you earn a share (currently 5%) of the
          points they earn after that. Referring yourself, creating accounts to
          refer, or paying or tricking people to sign up isn&apos;t allowed,
          and we may reverse referral rewards earned that way. Amounts may
          change.
        </p>
      </section>

      <section className="my-3">
        <h4>Bonuses, promotions and contests</h4>
        <p>
          From time to time we may run limited-time promotions, such as bonus
          points for a special event, point multipliers, challenges, random
          bonus rewards, or competitions like a weekly champion.
        </p>
        <ul className="terms-list">
          <li>
            Each promotion has its own rules, announced when it starts on our
            site, through our bots or on our social accounts. They say how long
            it runs, who can take part, how rewards are decided and any limits.
            Where a promotion&apos;s rules differ from these Terms, the
            promotion&apos;s rules apply to that promotion.
          </li>
          <li>No purchase is ever needed to take part or win.</li>
          <li>
            Promotions are void where prohibited, and we may limit who can take
            part by location or account status.
          </li>
          <li>
            We may change, pause or end a promotion early, for example because
            of fraud, technical problems or legal reasons. Rewards won by
            breaking the rules can be cancelled.
          </li>
          <li>
            Unless a promotion says otherwise, bonus rewards are points and
            follow the rules in &quot;Points and $BEACH&quot;. You&apos;re
            responsible for any taxes on prizes.
          </li>
        </ul>
      </section>

      <section className="my-3">
        <h4>Your photos and content</h4>
        <p>
          You keep ownership of the photos and messages you send us. You give
          us a worldwide, royalty-free license to store, analyze and use them
          to run, verify and improve the Program, and to show cleanup results
          and totals, and to feature your cleanup photos in Beach Collective
          posts, on our website and in other materials, credited to your display
          name. You can ask us to stop featuring a photo at any time. Only
          send content you have the right to share, and don&apos;t include
          other people&apos;s faces or private information without their
          permission.
        </p>
      </section>

      <section className="my-3">
        <h4>Things you must not do</h4>
        <ul className="terms-list">
          <li>
            Cheat the Program: fake, staged or duplicate cleanups, multiple
            accounts, self-referrals or automated submissions.
          </li>
          <li>
            Interfere with or attack the Program, get around rate limits or bot
            protection, or try to access other people&apos;s accounts or data.
          </li>
          <li>
            Use the bots or the Program to harass anyone, or to post illegal,
            hateful, sexual or harmful content.
          </li>
          <li>Impersonate Beach Collective, our team or another person.</li>
          <li>
            Use the Program to break any law, including sanctions and
            money-laundering laws.
          </li>
        </ul>
      </section>

      <section className="my-3">
        <h4>Other services and wallets</h4>
        <p>
          The Program works with services we don&apos;t control, including X,
          Telegram, crypto wallets and blockchain networks. Their terms apply
          to your use of them, and we aren&apos;t responsible for their
          outages, fees or actions. We never hold your wallet&apos;s private
          keys and can&apos;t reverse blockchain transactions.
        </p>
      </section>

      <section className="my-3">
        <h4>$BEACH is not an investment</h4>
        <p>
          $BEACH is a reward for cleanups. Nothing in the Program is investment,
          financial, legal or tax advice, or an offer to sell securities. The
          value of $BEACH can go up or down, including to zero, and may not be
          tradable anywhere. Don&apos;t take part expecting a profit. For more
          on the risks of holding crypto tokens, see our{" "}
          <a
            className="text-dark"
            href="https://beachcollective.io/risk-disclosure"
          >
            Cryptocurrency Risk Disclosure
          </a>
          .
        </p>
      </section>

      <section className="my-3">
        <h4>Disclaimers</h4>
        <p>
          The Program is provided &quot;as is&quot; and &quot;as available&quot;.
          To the extent the law allows, we make no promises that it will be
          uninterrupted, error-free or secure, that verification results or
          weight estimates are accurate, or about the value or availability of
          $BEACH.
        </p>
      </section>

      <section className="my-3">
        <h4>Limit of liability</h4>
        <p>
          To the extent the law allows, Beach Collective isn&apos;t liable for
          indirect, incidental, special or consequential damages, lost profits
          or lost tokens, or for injuries or losses from taking part in
          cleanups. Our total liability for any claim about the Program is
          limited to the greater of $100 or the value of the $BEACH paid to you
          in the 12 months before the claim. You agree to cover Beach
          Collective&apos;s reasonable costs, including legal fees, from
          claims caused by your content, your breach of these Terms or your
          conduct during cleanups.
        </p>
      </section>

      <section className="my-3">
        <h4>Suspending or closing accounts</h4>
        <p>
          You can stop using the Program and ask us to delete your account at
          any time. We may suspend or close accounts, and cancel unclaimed
          points, for breaches of these Terms, fraud, legal reasons, or if we
          end the Program. Sections that by their nature should continue, such
          as the content license, disclaimers and limits of liability, survive.
        </p>
      </section>

      <section className="my-3">
        <h4>Governing law and disputes</h4>
        <p>
          These Terms are governed by the laws of the State of Florida, USA.
          Disputes will be handled in the state or federal courts in Miami-Dade
          County, Florida, unless the law where you live requires otherwise.
        </p>
      </section>

      <section className="my-3">
        <h4>Changes to these Terms</h4>
        <p>
          We may update these Terms. For important changes we&apos;ll update
          the effective date and give notice on the site or through the bots
          before they take effect. Continuing to use the Program after that
          means you accept the new Terms.
        </p>
      </section>

      <section className="my-3">
        <h4>General</h4>
        <p>
          These Terms, our Privacy Policy and the rules of any promotion you
          join are the whole agreement between you and us about the Program.
          If any part is found unenforceable, the rest still applies. If we
          don&apos;t enforce a part right away, we can still enforce it later.
          You can&apos;t transfer your account or these Terms to anyone else.
          We may transfer them as part of a merger, sale or reorganization of
          our business.
        </p>
      </section>

      <section className="my-3">
        <h4>Contact</h4>
        <p>
          <a className="text-dark" href="mailto:hello@beachtoken.io">
            hello@beachtoken.io
          </a>
          .
        </p>
      </section>
    </div>
    <section className="footer-shape">
      <img src="/images/footer-top-shape.png" alt="" />
    </section>
    <Footer />
  </Base>
);

export default Terms;
